<template>
    <div class="main">
        <v-form
          ref="form"
        >
             <v-text-field
                dense
                v-model="title"
                label="Title"
                class="inputWidth mt-1 mb-3"
                clearable
                :rules="valueRequiredRule"
                validate-on-blur
            ></v-text-field>

            <v-select
             dense
             v-model="issueTypeId"
             :items="commIssueTypeList"
             item-text="displayName"
             item-value="id"
             label="Issue Types"
             :disabled="updateMode"
             class="inputWidth mt-1 mb-3"
             :rules="valueRequiredRule"
             @change="resetCommTypeSelected">
            </v-select>

            <v-select
             dense
            v-model="commTemplateTypeId"
             :items="announcementTypes"
             item-text="displayName"
             item-value="id"
             label="Announcement Types"
             class="inputWidth mt-1 mb-3"
             :disabled="updateMode"
             :rules="valueRequiredRule"
             @change="loadTemplate">
            </v-select>

            <v-select
             dense
             v-model="commTypeId"
             :items="commTypeList"
             item-text="displayName"
             item-value="id"
             label="Communication Type"
             class="inputWidth mt-1 mb-3"
             :rules="valueRequiredRule">
        </v-select>

            <v-select
             dense
            v-if="availableRetailerShow"
             v-model="retailerSelected"
             :items="retailers"
             multiple
             clearable
             item-text="displayName"
             item-value="id"
             label="Available Retailer(s)"
             class="mt-1 mb-3"
             >
            </v-select>


            <v-select
             dense
                v-if="typeShow"
                label="Data Delay Type"
                v-model="dataDelayTypes"
                multiple
                item-text="displayName"
                item-value="id"
                :items="commDataDelayTypeList"
                class="mt-1 mb-3">
                <template v-slot:prepend-item>
                    <v-list-item
                    ripple
                    @click="toggleDataDelayTypeSelectAll"
                    >
                    <v-list-item-action>
                        <v-icon color="primary">
                        {{ dataDelayTypesIcon }}
                        </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                        Select/Deselect All
                        </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
            </v-select>

            <v-select
             dense
                v-if="causeShow"
                label="Cause"
                v-model="causeId"
                item-text="displayName"
                item-value="id"
                :items="commDataDelayCauseList"
                class="inputWidth mt-1 mb-3">
            </v-select>

            <data-variance-editor
             v-if="dataVarianceShow"
             label="Data Variance"
             :minHeight="300"
             :height="300"
             v-model="dataVariance"
            ></data-variance-editor>

             <v-select
              dense
             v-if="officeLocationShow"
             v-model="countryId"
             :items="commCountryList"
             item-text="displayName"
             item-value="id"
             label="Office Location"
             class="inputWidth mt-1 mb-3"
             :rules="valueRequiredRule">
            </v-select>

              <v-select
               dense
             v-if="holidayShow"
             v-model="holidayId"
             :items="holidays"
             item-text="displayName"
             item-value="id"
             label="Holiday"
             class="inputWidth mt-1 mb-3"
             :rules="valueRequiredRule">
            </v-select>


            <free-message-editor
            v-if="bodyShow"
            label="Body"
            v-model="body"
            :minHeight="300"
            :height="300"
            ></free-message-editor>

         <user-group-input label="Available User Group(s)" :userGroupTypes="commUserGroupTypeList" v-model="selectedUserGroups" class="mt-3 mb-4"></user-group-input>

        <v-combobox
         dense
            v-if="affectedSystemShow"
            v-model="affectedSystem"
            :items="commAffectedSystemList"
            item-text="displayName"
            item-value="id"
            clearable
            label="Affected System"
            class="mt-1 mb-3"
            multiple
            :rules="[comoboxRequired]"
        >
        </v-combobox>

        <v-select
         dense
             v-model="timezoneSname"
             :items="commTimezoneList"
             item-text="timezone"
             item-value="timezoneSname"
             label="Default Timezone"
             class="inputWidth mt-1 mb-3"
            :rules="valueRequiredRule">
        </v-select>

        <date-input 
          v-if="dateAffectedShow"
          label="Date Affected"
          :rules="valueRequiredRule"
          v-model="affectedDate"
          textReadOnly
          inputClass="inputWidth mt-1 mb-3"
          :formatFunction="formatEnglishLocaleDate"
         ></date-input>

         <date-range-input 
          v-if="dateAffectedRangeShow"
          label="Date Affected"
          :rules="valueRequiredRule"
          v-model="dateAffectedRange"  
          textReadOnly
          inputClass="inputWidth mt-1 mb-3"
         ></date-range-input>

          <v-select
           dense
             v-if="startTimeShow"
             v-model="startTime"
             :items="timeList"
             label="Start Time"
             class="inputWidth mt-1 mb-3"
             :rules="valueRequiredRule">
        </v-select>

         <v-text-field
          dense
                v-if="durationShow"
                v-model="duration"
                label="Duration (Hours)"
                class="inputWidth mt-1 mb-3"
                clearable
                :rules="noneNegativeNumberRule"
                type="number"
        ></v-text-field>

         <date-input 
          dense
          v-if="etaShow"
          label="ETA"
          v-model="eta"
          textReadOnly
          :min="today"
          inputClass="inputWidth mt-1 mb-3"
          :formatFunction="formatEnglishLocaleDate"
         ></date-input>

         <date-input 
          dense
           label="Expiration Date" 
           :rules="valueRequiredRule"
           v-model="expires"           
           :min="today"
           inputClass="inputWidth mt-1 mb-3"
           ></date-input>

           

            <div style="width:140px">
                <v-checkbox
             dense
             hide-details
            v-model="addTimeStamp"
            label="Add Time Stamp"
              class="mt-1 "
            ></v-checkbox>
            </div>
            
            <div style="width:220px">
            <v-checkbox
             dense
             hide-details
            v-model="acknowledgement"
            label="Acknowledgement Required"
              class="mt-1 "
            ></v-checkbox>
            </div>   
                
            <div style="width:90px">
            <v-checkbox
             dense
             hide-details
            v-model="isSticky"
            label="Is Sticky"
            class="mt-1 "
            ></v-checkbox>
            </div>

             <div style="width:90px">
             <v-checkbox
              dense
              hide-details
            v-model="publish"
            label="Publish"
            class="mt-1 "
            ></v-checkbox>
             </div>

            <v-btn
                 small
                class="mr-4 mt-2"
                color="primary"
                @click="validate"
                width=70
            >
             Save
          </v-btn>

          <v-btn
                 small
                 color="primary"
                 class="mr-4 mt-2"
                  width=70
                @click="cancel"
            >
             Cancel
          </v-btn>
            
        </v-form>
    </div>
</template>
<script>
import UserGroupInput from "@/components/Communication/UserGroupInput";
import DateInput from "@/components/Communication/DateInput";
import DateRangeInput from "@/components/Communication/DateRangeInput";
import FreeMessageEditor from "@/components/Communication/FreeMessageEditor";
import DataVarianceEditor from "@/components/Communication/DataVarianceEditor"

const ISSUE_TYPE_DOWN_TIME = 1;
// const ISSUE_TYPE_DATE_DELAYS = 2;
// const ISSUE_TYPE_OTHERS = 3;
const ANNOUNCEMENT_TYPE_SYSTEM_MAINTENANCE = 2;
const ANNOUNCEMENT_TYPE_SYSTEM_MAINTENANCE_CN = 1;
const ANNOUNCEMENT_TYPE_SYSTEM_RELEASE = 3;
const ANNOUNCEMENT_TYPE_SYSTEM_RELEASE_CN = 4;
// const ANNOUNCEMENT_TYPE_DATA_DELAY = 5;
//const ANNOUNCEMENT_TYPE_DATA_STATUS_WALMART = 8;
// const ANNOUNCEMENT_TYPE_DATA_QUALITY = 7;
// const ANNOUNCEMENT_TYPE_DATA_DELAY_CN = 6;
// const ANNOUNCEMENT_TYPE_HOLIDAY = 10;
//const ANNOUNCEMENT_TYPE_FREE_MESSAGE = 9;
const DEFAULT_TIMEZONE_US_EST = 'EST';
const timeList =["12:00AM","1:00AM","2:00AM","3:00AM","4:00AM","5:00AM","6:00AM",
"7:00AM","8:00AM","9:00AM","10:00AM","11:00AM","12:00PM","1:00PM","2:00PM","3:00PM",
"4:00PM","5:00PM","6:00PM","7:00PM","8:00PM","9:00PM","10:00PM","11:00PM"];
const DYNAMIC_VARIABLE_CUBE_NAME = "%Cube Name%";
const DYNAMIC_VARIABLE_RETAILER = "%Retailer%";
const STATIC_VARIABLE_AFFECTED_SYSTEM = "{AffectedSystem}";
const STATIC_VARIABLE_CAUSE = "{cause}";
const STATIC_VARIABLE_DATA_VARIANCE = "{DataVariance}";
const STATIC_VARIABLE_DATE = "{Date}";
const STATIC_VARIABLE_DURATION = "{Duration}";
const STATIC_VARIABLE_END_TIME = "{EndTime}";
const STATIC_VARIABLE_ETA = "{ETA}";
const STATIC_VARIABLE_HOLIDAY= "{Holiday}";
const STATIC_VARIABLE_OFFICE_LOCATION = "{Office Location}";
const STATIC_VARIABLE_RETAILER = "{Retailer}";
const STATIC_VARIABLE_START_TIME = "{StartTime}";
const STATIC_VARIABLE_TYPE = "{Type}";


export default {
    name:"CommunicaionCreator",
    components:{
     "user-group-input":UserGroupInput,
     "date-input":DateInput,
     "date-range-input":DateRangeInput,
     "free-message-editor":FreeMessageEditor,
     "data-variance-editor":DataVarianceEditor
    },
    data() {
        return {
            valueRequiredRule:[
              v => !!v || 'Required.',
            ],
            noneNegativeNumberRule:[
              v => !!v || 'Required.',
              v => v>0 || 'Positive Number Only.',
            ],
            id:null,
            title:"",
            issueTypeId:null,
            commTemplateTypeId:null,
            countryId:null,
            holidayId:null,
            retailerSelected:[],
            dataDelayTypes:[],
            causeId:null,
            dataVariance:null,
            selectedUserGroups:[],
            affectedSystem:[],
            timezoneSname:null,
            dateAffectedRange:[],
            affectedDate:null,
            startTime:null,
            timeList:timeList,
            duration:null,
            eta:null,
            expires:null,
            commTypeId:null,
            linkedNeeded:false,
            addTimeStamp:false,
            acknowledgement:false,
            isSticky:false,
            publish:false,
            body:null,
            complete:false,
            permissionType:"communication",
            commUpdates:[],
            updateMode:false,
            variable:{
                cube_name: false,
                dynamic_retailer: false,
                affectedSystem: false,
                cause: false,
                dataVariance: false,
                date: false,
                duration: false,
                endTime: false,
                eta: false,
                holiday: false,
                officeLocation: false,
                staticRetailer: false,
                type: false,
                startTime: false
            }
        }
    },
    watch:{
        body(){            

            if(null == this.id && typeof this.body != "undefined"){
                console.log("body is modified");

                this.variable.cube_name = this.body.includes(DYNAMIC_VARIABLE_CUBE_NAME)? true: false;

                this.variable.dynamic_retailer = this.body.includes(DYNAMIC_VARIABLE_RETAILER)? true: false;

                this.variable.affectedSystem = this.body.includes(STATIC_VARIABLE_AFFECTED_SYSTEM)? true: false;

                this.variable.cause = this.body.includes(STATIC_VARIABLE_CAUSE)? true: false;

                this.variable.dataVariance = this.body.includes(STATIC_VARIABLE_DATA_VARIANCE)? true: false;

                this.variable.date = this.body.includes(STATIC_VARIABLE_DATE)? true: false;

                this.variable.duration = this.body.includes(STATIC_VARIABLE_DURATION)? true: false;

                this.variable.endTime = this.body.includes(STATIC_VARIABLE_END_TIME)? true: false;

                this.variable.eta = this.body.includes(STATIC_VARIABLE_ETA)? true: false;

                this.variable.holiday = this.body.includes(STATIC_VARIABLE_HOLIDAY)? true: false;

                this.variable.officeLocation = this.body.includes(STATIC_VARIABLE_OFFICE_LOCATION)? true: false;

                this.variable.staticRetailer = this.body.includes(STATIC_VARIABLE_RETAILER)? true: false;

                this.variable.type = this.body.includes(STATIC_VARIABLE_TYPE)? true: false;

                this.variable.startTime = this.body.includes(STATIC_VARIABLE_START_TIME)? true: false;
            }
        }
    },
    computed:{
        announcementTypes(){
            if(this.issueTypeId != null){
                return this.commTemplateTypeList.filter( dataDelayTypes => dataDelayTypes.issueTypeId == this.issueTypeId);
            }else{
                return [];
            }
        },
        today(){
            return (new Date(Date.now()-(new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
        },
        holidays(){
            if(this.countryId != null){
                return this.commHolidayList.filter( holiday => holiday.countryId == this.countryId);
            }else{
                return [];
            }
        },
        affectedSystemShow(){
            return this.variable.affectedSystem;
        },
        dateAffectedShow(){
            return (null == this.id) && (this.issueTypeId == ISSUE_TYPE_DOWN_TIME && (
                this.commTemplateTypeId == ANNOUNCEMENT_TYPE_SYSTEM_MAINTENANCE ||
                this.commTemplateTypeId == ANNOUNCEMENT_TYPE_SYSTEM_MAINTENANCE_CN ||
                this.commTemplateTypeId == ANNOUNCEMENT_TYPE_SYSTEM_RELEASE ||
                this.commTemplateTypeId == ANNOUNCEMENT_TYPE_SYSTEM_RELEASE_CN)
                );
        },
        startTimeShow(){
                return this.variable.startTime;
        },
        durationShow(){
                return this.variable.duration;
        },
        typeShow(){
            return this.variable.type;
        },
        causeShow(){
            return this.variable.cause;
        },
        dataVarianceShow(){
            return this.variable.dataVariance;

        },
        etaShow(){
            return this.variable.eta;
        },
        availableRetailerShow(){
            return this.variable.staticRetailer;
        },
        officeLocationShow(){
            return this.variable.officeLocation;
        },
        holidayShow(){
            return this.variable.holiday;
        },
        dateAffectedRangeShow(){
            return !this.dateAffectedShow && this.variable.date;
        },
        bodyShow(){
            return true;
        },
        fields(){
            return this.$store.getters.getCommuicationFields;
        },
        commAffectedSystemList(){
            return (this.fields && this.fields.commAffectedSystemList) ? this.fields.commAffectedSystemList:[];
        },
        commCountryList(){
            return (this.fields && this.fields.commCountryList) ? this.fields.commCountryList:[];
        },
        commHolidayList(){
            return (this.fields && this.fields.commHolidayList) ? this.fields.commHolidayList:[];
        },
        commDataDelayCauseList(){
            return (this.fields && this.fields.commDataDelayCauseList) ? this.fields.commDataDelayCauseList:[];
        },
        commDataDelayTypeList(){
            return (this.fields && this.fields.commDataDelayTypeList) ? this.fields.commDataDelayTypeList:[];
        },
        commIssueTypeList(){
            return (this.fields && this.fields.commIssueTypeList) ? this.fields.commIssueTypeList:[];
        },
        commTemplateTypeList(){
            return (this.fields && this.fields.commTemplateTypeList) ? this.fields.commTemplateTypeList:[];
        },
        commTimezoneList(){
            return (this.fields && this.fields.commTimezoneList) ? this.fields.commTimezoneList:[];
        },
        commTypeList(){
            return (this.fields && this.fields.commTypeList) ? this.fields.commTypeList:[];
        },
        commUserGroupTypeList(){
            return (this.fields && this.fields.commUserGroupTypeList) ? this.fields.commUserGroupTypeList:[];
        },
        retailers(){
            return (this.fields && this.fields.retailers) ? this.fields.retailers:[];
        },
        selectAllDataDelayType () {
        return this.dataDelayTypes.length === this.commDataDelayTypeList.length;
        },
        selectSomeDataDelayType () {
            return this.dataDelayTypes.length > 0 && !this.selectAllDataDelayType;
        },
        dataDelayTypesIcon () {
            if (this.selectAllDataDelayType) {
                return 'mdi-close-box';
            }else if (this.selectSomeDataDelayType) {
                return 'mdi-minus-box';
            }
            return 'mdi-checkbox-blank-outline';
        },
    },
    async mounted(){
        this.$refs.form.reset();
        this.timezoneSname = DEFAULT_TIMEZONE_US_EST;
        this.$vuetify.goTo(0);
        this.complete = false;
        this.$store.dispatch("fetchCommunicationField");
        if(this.$route.params && this.$route.params.communicationId){
            console.log("Load Communication, communication Id:",this.$route.params.communicationId)
          const response = await this.$store.dispatch("loadCommunication",this.$route.params.communicationId);
          if(response && !response.error){
              this.copyData(response,this);
              this.updateMode = true;
              if(response.commPermissions != null){
                this.selectedUserGroups = response.commPermissions.map(ele => {
                    const userGroup = ele;
                    userGroup.displayName = ele.repGroup;
                    return userGroup;
                });
              }
              

              if(response.retailers != null && response.retailers != ""){
                  this.retailerSelected = response.retailers.split(",").map(name => {
                        const element = this.retailers.find(e => e.displayName === name);
                        return element.id;
                    })
              } 

              if(response.affectedSystems != null && response.affectedSystems!= ""){
                    this.affectedSystem = response.affectedSystems.split(",").map(ele => {
                        const index = this.commAffectedSystemList.findIndex(e => e.displayName === ele);
                        if(index == -1){
                            return ele;
                        }else{
                            return this.commAffectedSystemList[index];
                        }
                    });
              }
              

            //deal with Data Delay Type
            if(response.dataDelayTypeId != null && response.dataDelayTypeId !="" ){
                this.dataDelayTypes = response.dataDelayTypeId.split(",").map(ele => parseInt(ele));
            }
            
            //deal with affect dates
            if(response.affectedDateEnd != null && response.affectedDateEnd != "" ){
                this.dateAffectedRange = [];
                this.dateAffectedRange.push(response.affectedDate)
                this.dateAffectedRange.push(response.affectedDateEnd);
            }


            
          }
        }else{
            this.updateMode = false;
        }
    },
    methods:{
        resetCommTypeSelected(){
            this.commTypeId = null;
        },
        comoboxRequired(value){
             if (value instanceof Array && value.length == 0) {
                return 'Required.';
            }
            return !!value || 'Required.';
        },
        formatEnglishLocaleDate(date){
            if (!date) {
                return null;
            }
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',timeZone: 'UTC' };
            const dt = new Date(date);
            return dt.toLocaleDateString("en-US", options);
        },
        validate(){
            const valid = this.$refs.form.validate();
            if(!valid) {
                return;
            }
            const confirmObject = {};
            confirmObject.showDlg= true;
            confirmObject.buttons={
                OKButton:{
                    Caption:"OK"
                },
                CancelButton:{
                    Caption:"Cancel"
                }
            };
            confirmObject.title="Warning Message";
            confirmObject.message="Before saving the announcement, make sure that the permission list (REP user groups) you specified and the information you entered correct. To continue, click OK. To make a change, click Cancel.";
            confirmObject.submitCallback = this.submit;
            this.$store.dispatch("setConfirmDialogDetails",confirmObject);
        },
        cancel(){
            this.$router.go(-1);
        },
        async submit(){
            const communicationEntity={};
            this.copyData(this,communicationEntity);
            
            communicationEntity.retailers = this.retailerSelected.map(id => {
                const element = this.retailers.find(e => e.id === id);
                return element.displayName;
            }).join();

            communicationEntity.dataDelayTypeId = this.dataDelayTypes.join();

            communicationEntity.commPermissions = this.selectedUserGroups.map(ele => {
                const permission = ele;  
                permission.groupType =  permission.groupType?permission.groupType:null;
                permission.type = permission.type?permission.type:this.permissionType;
                return permission;
            });

            //deal with affect dates
            if(this.dateAffectedRangeShow){
                communicationEntity.affectedDate = this.dateAffectedRange[0];
                communicationEntity.affectedDateEnd =  this.dateAffectedRange[1];
            }

            communicationEntity.affectedSystems = this.affectedSystem.map(ele => ele.displayName?ele.displayName:ele).join();
            this.complete = true;
            await this.$store.dispatch("saveCommunication",{entity:communicationEntity,userId:this.$store.getters.getUserId,callbackFunc:()=>{
                this.$router.push("/communication/manage");
            }});
        },
        copyData(from,to){
            to.id = from.id;
            to.title = from.title;
            to.body = from.body;
            to.issueTypeId=from.issueTypeId;
            to.commTemplateTypeId = from.commTemplateTypeId;
            to.causeId = from.causeId;
            to.dataVariance = from.dataVariance;
            to.countryId = from.countryId;
            to.holidayId = from.holidayId;
            to.commTypeId = from.commTypeId;
            to.eta = from.eta;
            to.affectedDate = from.affectedDate;
            to.startTime = from.startTime;
            to.duration = from.duration;
            to.expires = from.expires;
            to.addTimeStamp = from.addTimeStamp;
            to.acknowledgement = from.acknowledgement;
            to.linkedNeeded = from.linkedNeeded;
            to.publish = from.publish;
            to.isSticky = from.isSticky;
            to.commUpdates = from.commUpdates;
            to.timezoneSname= from.timezoneSname;
        },
        async loadTemplate(commTemplateTypeId){
            if(!this.updateMode){
                 const response = await this.$store.dispatch("loadTemplate",this.commTemplateTypeId);
                if(response && !response.error){
                    this.body = response.template;
                }
            }
        this.announcementTypes.filter(commTypes => {
                if(commTypes.displayName === 'Free Message' && commTemplateTypeId === commTypes.id){
                        this.commTypeList.filter(commType => {
                            if(commType.displayName === 'General Communications'){
                                this.commTypeId = commType.id;
                                return;
                            }
                        })
                }
            })
            
        },
        toggleDataDelayTypeSelectAll(){
            this.$nextTick(() => {
            if (this.selectAllDataDelayType) {
                this.dataDelayTypes = []
            } else {
                this.dataDelayTypes = this.commDataDelayTypeList.map(dataType => dataType.id);
            }
            });
        }
    },
    beforeRouteLeave(from,to,next){
      //form is not saved
      //fix session expired page not redirect error
      if(!this.complete && from.name !="ErrorPage"){
        const confirmObject = {};
            confirmObject.showDlg= true;
            confirmObject.buttons={
                OKButton:{
                    Caption:"OK"
                },
                CancelButton:{
                    Caption:"Cancel"
                }
            };
            confirmObject.title="Warning";
            confirmObject.type="Info";
            confirmObject.message="Do you really want to leave? the unsaved changes will be lost.";
            confirmObject.submitCallback =  () =>{
                next();
                }
            confirmObject.cancelCallback =  () =>{
                next(false);
                }
            this.$store.dispatch("setConfirmDialogDetails",confirmObject);
            return;
      }else{
          next();
      }
    }
}
</script>
<style lang="scss" scoped>
.main{
     margin-top:1%;
     margin-left:10%;
     margin-right:10%;
     margin-bottom: 2%;
     width: 65%;
     height: 100%;
}
</style>
<style lang="scss">
.inputWidth{
    width:40%
}
.tox-tinymce-aux{
    z-index:204 !important;
}
</style>